import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import communityService from "../../api/communityService";

export const searchUsers = createAsyncThunk(
  "/community/searchUsers",
  async ({ query, limit = 5 }, { rejectWithValue }) => {
    try {
      const response = await communityService.searchUsers(query, limit);
      // Return the data array directly from the API response
      return response?.data?.data || response?.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const rePost = createAsyncThunk(
  "/community/rePost",
  async ({ original_post_id }, { rejectWithValue }) => {
    try {
      const response = await communityService.rePost({
        original_post_id,
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const follow = createAsyncThunk(
  "/community/follow",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await communityService.follow({
        id,
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const submitRequestedRole = createAsyncThunk(
  "/community/submitRequestedRole",
  async ({ role_name }, { rejectWithValue }) => {
    try {
      const response = await communityService.submitRequestedRole(role_name);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
const initialState = {
  searchUsersItems: {},
  rePostItems: {},
  followItems: {},
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  successMessage: "",
};

const communitySlice = createSlice({
  name: "career",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchUsers.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(searchUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.searchUsersItems = action.payload || "";
        state.errorMessage = "";
      })
      .addCase(searchUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(rePost.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(rePost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.rePostItems = action.payload || "";
        state.errorMessage = "";
      })
      .addCase(rePost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(follow.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(follow.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.followItems = action.payload || "";
        state.errorMessage = "";
      })
      .addCase(follow.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      });
  },
});

export default communitySlice.reducer;
